import questions from "../../assets/js/helpMultilngual/bs_kr_questions";
import troubles from "../../assets/js/helpMultilngual/bs_en_troubles";
const kr = {
  language: "한국어",
  bstext: {
    bs1: "배터리 교환 요금제",
    bs2: "요금제 상세",
    bs3: "사용 설명",
    bs4: "개통을 원합니다.",
    bs5: "다음 단계",
    bs6: "변경 확인",
    bs7: "요금제 변경",
    bs8: "배터리 교환 요금제",
    bs9: "성공적으로 변경되었습니다 ",
    bs10: "성공적으로 개통되었습니다",
    bs11:
      "배터리 교환 기능을 사용하려면, 가능한 빨리 블루샤크 오프라인 매장으로 가서 활성화하십시오. 활성화 후 요금제를 취소해야 하는 경우, 오프라인 서비스센터로 가서 처리하시기 바랍니다.",
    bs12: "{msg} 초 후에 되돌아갑니다.",
    bs13: "이전 청구서",
    bs14: "결제 대기 중",
    bs15: "현재 청구서 정보가 없습니다.",
    bs16: "년",
    bs17: "{msg} 월 청구서",
    bs18: "{msg}월 청구 금액",
    bs19: "요금제 비용",
    bs20: "단일 배터리 요금제",
    bs21: "듀얼 배터리 요금제",
    bs22: "배터리 교환 비용",
    bs23: "이번 달 배터리 교환 총 킬로와트시",
    bs24: "암페어시간",
    bs25: "변경 수수료",
    bs26: "업그레이드 수수료",
    bs27: "결제 시간",
    bs28: "결제 방식",
    bs29: "요금 설명",
    bs30: "청구서 요금 = 요금제 요금 + 배터리 교환 요금 + 변경 수수료",
    bs31: "요금제 요금 = 월 요금제 고정 요금 (1 개월 미만의 경우 일할계산) ",
    bs32:
      "배터리 교환 요금 = 주기 내의 배터리 교환에 소요된 총 암페어시간 * 2 위안 ",
    bs33: "변경 수수료 = 3 개월 초과 사용시 업그레이드 수수료",
    bs34: "결제하러 가기",
    bs35: "계산서를 결산하다",
    bs36: "정보 없음",
    bs37: "미결산청구서",
    bs38: "지금까지",
    bs39: "미청구",
    bs40: "청구일",
    bs41: "최종 지급일",
    bs42: "정상적인 사용을 위해 빠른 결제를 해주시기 바랍니다",
    bs43: "현재 청구서 정보가 없습니다",
    bs44: "내 청구서",
    bs45: "개통",
    bs46: "배터리 교환 요금제가 개통되지 않았습니다",
    bs47: "내 요금제",
    bs48: "변경하고 싶은 요금제를 선택하십시오",
    bs49: "개통 시간",
    bs50: "활성화 시간",
    bs51: "종료 시간",
    bs52: "변경 시간",
    bs53: "요금제 취소",
    bs54:
      "고객님의 첫 요금제 사용이 3 개월을 초과하였습니다. 변경을 위해 변경 수수료 3,000 TWD (신 대만 달러)를 지불해야 하는 경우 수수료는 이달 청구서에 포함됩니다. 확인 후 변경하십시오.",
    bs55: "나중에",
    bs56: "내용을 이해하였고, 변경을 확인합니다.",
    bs57: "취소하시겠습니까?",
    bs58: "취소",
    bs59: "확인",
    bs60: "내 요금제",
    bs61: "당신은 이미 {msg} 요금제로 취소",
    bs62:
      "고객님의 첫 요금제 사용이 3 개월을 초과하였습니다. 변경을 위해 변경 수수료 3,000 TWD (신 대만 달러)를 지불해야 하는 경우 수수료는 이달 청구서에 포함됩니다.",
    bs63: "정보 확인",
    bs64:
      "{name} 요금제로 변경할 경우, 요금제는 익일부터 적용되며, 변경 후 해당 월의 청구서는 두 요금제의 실제 사용 일을 근거로 일할계산됩니다. 확인하십시오 !",
    bs65: "지불해야 할 금액",
    bs66: "결제 방식을 선택하십시오",
    bs67: "결제",
    bs68: "오류 코드 :",
    bs69: "완료",
    bs70: "다시 지불한다",
    bs71: "지불 을 취소 하 다",
    bs72: "불러오는 중",
    bs73: "결제 성공",
    bs74: "결제 실패",
    bs75: "페이지 이동"
  },
  bsstatus: {
    // 结算周期
    cycles: [
      {
        key: 1,
        val: "월"
      }
    ],
    // 套餐状态
    menus: [
      {
        key: "1",
        val: "활성화되지 않음"
      },
      {
        key: "2",
        val: "사용 중"
      },
      {
        key: "3",
        val: "변경됨"
      },
      {
        key: "4",
        val: "종료됨"
      }
    ],
    // 支付方式
    payMethods: [
      {
        key: "CARD",
        val: "Credit Card"
      },
      {
        key: "BANK",
        val: "Bank Transfer"
      },
      {
        key: "VBANK",
        val: "Virtual Account"
      }
    ],
    // 支付状态
    payStatuss: [
      {
        key: "1",
        val: "결제 대기 중"
      },
      {
        key: "2",
        val: "지불완료"
      },
      {
        key: "3",
        val: "연체됨"
      },
      {
        key: "4",
        val: "아직 결제하"
      }
    ]
  },
  helpCenter: {
    documentTitle: "고객센터",
    title: [
      "차량 연결 및 활성화",
      "계정 문제",
      "차량 운행",
      "첨단 운전자 지원 시스템",
      "정보와 엔터테인먼트",
      "앱 사용 안내서",
      "차량 업데이트",
      "배터리 안전",
      "유지 보수",
      "오류 자가 진단"
    ],
    description: "Description:",
    solution: "Suggested Solution:",
    exAssistance: "교환 전지 도움말",
    exAssistanceList: [
      "블루샤크 스마트 배터리 교환 서비스에 관하여",
      "교환 전지 계정에 대하여",
      "교환 전지 패키지에 대하여",
      "배터리 교환 서비스 사용 방법에 대해."
    ],
    exAssistanceSubtitle: [
      ["블루샤크 스마트 배터리 교환 서비스에 관하여"],
      [
        "어떻게 교환 전지 계정을 얻을 수 있나요?",
        "배터리 교환 계정은 어떤 용도로 사용되나요?"
      ],
      [
        "교환 전지 패키지란 무엇인가요?",
        "이번 달 한도가 남아 있으면 다음 달에 사용할 수 있나요?",
        "구매한 배터리 교환 패키지를 환불할 수 있나요?",
        "구매한 배터리 교환 패키지를 연장할 수 있나요?",
        "배터리 교환 패키지의 유효일자 규칙은 어떻게 되나요?"
      ],
      [
        "패키지 구매 후 처음으로 배터리 교환을 어떻게 진행해야 하나요?",
        "배터리 교환을 어떻게 진행하나요?",
        "각 배터리 교환함 위치의 배터리 정보를 어떻게 조회하나요?",
        "배터리 교환 실패의 가능한 원인은 무엇인가요?"
      ]
    ],
    exAssistanceInfo: [
      [
        [
          "란샤 지능형 배터리 교환 서비스는 란샤가 특정 수요 시장을 위해 제공하는 신속한 에너지 보급 서비스로, 배터리 교환 박스 설치, 배터리 임대 서비스, 교환 서비스 기능 등이 포함돼 있어 전기 모터사이클의 주행 거리 부족한 단점을 효과적으로 해결하며, 최단 3초 안에 보급 및 교환을 완료할 수 있습니다. ",
          "각 시장의 수요 상황 차이로 란샤 지능형 배터리 교환 서비스는 모든 란샤 차량의 판매 지역을 완벽히 커버하지 않습니다. 일부 판매 지역에서는 관련된 배터리 교환 보급 서비스를 제공하지 않으며, 구체적인 사항은 현지 판매점이나 판매 대리점에 문의하시기 바랍니다."
        ]
      ],
      [
        [
          "귀하가 계신 지역에서 블루샤크 지능형 배터리 교환 서비스가 개통되었다면, 먼저 블루샤크 앱을 다운로드하고 성공적으로 앱 계정을 등록해야 합니다. 앱의 홈페이지에서 '배터리 교환 서비스' 기능 카드를 찾을 수 있습니다.",
          "'배터리 교환 서비스' 기능 카드를 선택한 후 적합한 배터리 교환 사업자를 선택하고 '배터리 교환 서비스 계약'을 읽고 동의하면 배터리 교환 계정 생성이 완료됩니다. ",
          "귀하가 계신 지역에서 블루샤크 지능형 배터리 교환 서비스가 아직 개통되지 않았다면, '배터리 교환 서비스' 기능 카드에 접근할 수 없으며 배터리 교환 계정을 생성할 수 없습니다."
        ],
        [
          "배터리 교환 계정은 블루샤크 지능형 배터리 교환 서비스를 이용하기 위한 유일한 식별 계정입니다. 배터리 교환 계정이 없으면 배터리 교환 서비스 혜택을 누릴 수 없습니다. 배터리 교환 계정은 배터리 교환 패키지 구매, 배터리 교환 서비스 이용, 배터리 교환 한도 및 자산 관리, 배터리 교환 기록 및 소비 관리 등에 사용됩니다."
        ]
      ],
      [
        [
          "배터리 교환 패키지는 각 지역의 배터리 교환 비즈니스 요구에 따라 배터리 교환 사업자가 독립적으로 패키지 규칙 및 가격을 설정한 가상 혜택 전자 상품입니다. ",
          "현재 패키지 규칙은 전기 사용량에 따른 요금, 배터리 교환 횟수에 따른 요금, 무제한 배터리 교환 한도의 세 가지 요금 체계를 지원하며, 한도는 월 단위로 할당되며 요금 정산은 월, 분기, 연말 정산 방식을 지원합니다. 구체적인 선택 가능한 패키지는 선택한 운영자의 실제 규정에 따릅니다. ",
          "배터리 교환 패키지를 구매하면 배터리 교환 서비스 혜택을 받을 수 있으며, 오프라인 매장이나 딜러를 방문하여 배터리 교환 서비스 혜택을 수령하고 이를 활용할 수 있습니다."
        ],
        [
          "현재 배터리 교환 서비스 규칙에 따르면, 사용하지 않은 한도가 이번 달이 끝나고 다음 달 정산 주기에 진입할 때 초기화되며 다음 달로 누적되지 않습니다. 실제 전력 사용 요구에 따라 일상적인 사용에 적합한 배터리 교환 패키지를 선택해주세요."
        ],
        [
          "배터리 교환 패키지는 가상 혜택의 전자 상품이며, 배터리 교환 사용 규칙에 따라 환불이 불가능합니다. 구매 전에 신중히 평가한 후 구매하시기 바랍니다. 양해해 주셔서 감사합니다."
        ],
        [
          "배터리 교환 패키지 구매 시, 연장 규칙을 주의하시고, 연장 규칙을 만족하는 경우에는 연장이 가능합니다. 연장 후에는 배터리 교환 혜택이 '내 배터리' 페이지에서 지속적으로 누적됩니다. 실제 필요에 따라 합리적으로 구매 및 연장하시기 바랍니다."
        ],
        [
          "배터리 교환 패키지 구매 후, 다음 달 1일에 유효해집니다. 당장 유효하게 하려면 '당월 유효' 옵션을 선택하고 당월 유효한 패키지 한도를 보충하면 배터리 교환 패키지가 당장 유효해질 수 있습니다. 배터리 교환 패키지를 구매할 때 개인의 필요에 따라 합리적으로 패키지 활성화 시기를 계획해 주세요."
        ]
      ],
      [
        [
          "배터리 교환 패키지를 구매한 후, 먼저 앱의 안내에 따라 오프라인 매장이나 딜러 지점을 방문하여 배터리 교환 서비스 혜택을 받고 배터리를 등록해야 합니다. 대여 배터리인 경우, 오프라인 매장이나 딜러 지점을 방문하여 배터리를 대여하고 배터리 임대 보증금을 지불해야 합니다. ",
          "등록된 배터리는 바로 배터리 교환 서비스 혜택을 받을 수 있으며, 배터리를 배터리 교환함에 삽입하면 교환함에서 충전된 배터리나 고용량 배터리가 자동으로 나오며 교환 서비스 혜택이 새로 나온 배터리와 결합됩니다."
        ],
        [
          "사용자가 처음 배터리 교환을 등록한 후, 이후의 모든 배터리 교환은 단지 저전량 배터리를 교환함에 넣으면, 배터리 교환함은 자동으로 충전된 배터리나 고용량 배터리를 내보냅니다. ",
          "만약 배터리 교환함이 정상적으로 배터리를 내보내지 않는 경우, 배터리 교환함 화면 안내에 따라 고객센터에 문의하시기 바랍니다."
        ],
        [
          "Blueshark 앱의 배터리 교환 서비스 카드를 선택하여 배터리 교환 지도 홈페이지에서 근처 배터리 교환함 정보를 조회할 수 있습니다. 이 정보에는 배터리 교환함의 이름, 위치, 거리, 배터리 상태 개요 등이 포함되며, 배터리 교환함을 클릭하면 배터리 교환함의 상세 정보 페이지로 이동하여 배터리 정보를 확인할 수 있습니다."
        ],
        [
          "배터리 교환 실패의 가능한 원인은 다음과 같습니다:",
          "① 삽입한 배터리의 교환 서비스 기간이 만료되어 교환할 수 없는 경우입니다. 먼저 요금을 결제한 후 사용해야 합니다.",
          "② 교환함 내에 교환 가능한 배터리가 없는 경우입니다. 교환함 내의 배터리 전력이 모두 교환 조건을 충족하지 못하여 교환할 수 없는 상황이며, 다른 교환함으로 이동하여 교환할 수 있습니다.",
          "③ 위의 상황이 모두 정상적인 경우에도 여러 번 시도해도 배터리 교환에 실패하는 경우, 고객 서비스에 문의하십시오."
        ]
      ]
    ],
    quickGuide: "차량 빠른 습득 가이드",
    quickGuideList: [
      "기본 조작",
      "차량 활성화",
      "주차 기능",
      "운전 기능",
      "주행과 모드"
    ],
    QuickListSubtitle: [
      ["H1 2023 기본 조작", "R1 2023 기본 조작"],
      ["H1 2023 차량 활성화", "R1 2023 차량 활성화"],
      ["H1 2023 주차 기능", "R1 2023 주차 기능"],
      ["H1 2023 운전 기능", "R1 2023 운전 기능"],
      ["H1 2023 주행과 모드", "R1 2023 주행과 모드"]
    ],
    h1Node:
      "주: 이 가이드는 H1 2023에만 적용됩니다. H1 lite의 경우 설명서를 참조하십시오. 이 가이드는 빠른 시작 사용만 지원하며 자세한 작동은 설명서를 참조하십시오.",
    r1Node:
      "주: 이 가이드는 R1 2023에만 적용됩니다. R1 lite의 경우 설명서를 참조하십시오. 이 가이드는 빠른 시작 사용만 지원하며 자세한 작동은 설명서를 참조하십시오.",
    lightDescription: "지시등 설명",
    signalLeft: "좌회전 신호등",
    signalRight: "우회전 신호등",
    highBeam: "원격 조명",
    lowBeam: "근거리 조명",
    lowPowerLight: "저전압 경고등",
    faultLight: "고장 경고등",
    readyLight: "준비 상태 지시등",
    instrumentPic: "계기판 다이어그램",
    leftKeyDescription: "버튼 설명 (왼쪽 핸들)",
    leftHandPic: "왼손 핸들 다이어그램",
    rightKeyDescription: "버튼 설명 (오른쪽 핸들)",
    rightHandPic: "오른쪽 핸들 바 도면",
    overtakingLightKey: "추월등 스위치: 빛을 깜박이게 전환합니다",
    lowBeanKey: "저 빔 키 : 토글하여 근접 빔 켜기",
    highBeamKey: "원격 빔 키: 토글하여 원격 빔 켜기",
    configKey: "확인 키: 스마트 카드에서 확인 작업에 사용됩니다.",
    smartKey: "스마트 키: 스마트 카드에서 전환 및 제어에 사용됩니다.",
    LeftTrunSignalKey:
      "신호등 레버: 좌측으로 움직여 좌회전 신호를 활성화하며, 가운데를 눌러 신호를 끕니다.",
    RightTrunSignalKey:
      "신호등 레버: 우측으로 움직여 우회전 신호를 활성화하며, 가운데를 눌러 신호를 끕니다.",
    hornKey:
      "경적 버튼: 손으로 누르면 경적이 울리며, 손을 뗄 때 경적이 멈춥니다.",
    cruiseControlKey:
      "스피드 컨트롤 버튼: 짧게 눌러서 크루즈 컨트롤을 활성화합니다(차속 15km/h 이상일 때), 다시 짧게 누르거나 브레이크를 밟으면 크루즈 컨트롤을 비활성화합니다",
    waringKey:
      "차량 고장 또는 긴급 상황에서 위험 경고등을 활성화하려면 누릅니다.",
    costomKey: "사용자 정의 키: 업데이트 예정",
    turboKey: "TURBO 키: 짧게 눌러 TURBO 모드 진입, 다시 짧게 눌러 나옴",
    sportKey: "SPORT 키: 짧게 눌러 SPORT 모드 진입, 다시 짧게 눌러 나옴",
    openSeatKey: "시트 버킷 키: 차량 전원이 켜진 상태에서 좌석 버킷 열기",
    transferAssistanceKey:
      "이동 보조 키: 차량이 주행 상태이고 정지 상태 인 경우 MAM 키를 눌러 이동 보조 모드로 들어갑니다. 이 때 'M'을 돌리거나 핸들바를 돌려 차량을 느리게 전진 및 후진할 수 있습니다.",
    gearKey: "모드 버튼: 짧게 눌러 모드 전환",
    LeftGearKey: "기어 위치 키: 좌측으로 쉬프트하면 쉬프트 다운",
    RightGearKey: "기어 위치 키: 우측으로 쉬프트하면 쉬프트 업",
    volumeIncreaseKey:
      "볼륨 조절 키: 오른쪽 버튼을 짧게 눌러 볼륨을 증가시킵니다",
    volumedecreaseKey: "볼륨 조절 키: 왼쪽 키를 눌러 볼륨을 줄입니다",
    readyKey: "준비 키 : 짧게 누르면 주행 및 주차 모드 간 전환 가능",
    activationNode:
      "주의: 신차 출고 시 차량은 활성화되지 않은 상태입니다. 모든 기능과 서비스를 사용하려면 활성화해야 합니다.",
    activeCardPic: "자동차 활성화 카드 그림",
    activeUIPic: "자동차 활성화 인터페이스 그림",
    activeStep1: "1 단계 : 최초 부팅 페이지",
    activeStep2: "단계 2 : 앱 다운로드 안내 페이지",
    activeStep3: "3단계 : 활성화 페이지 조작 안내",
    activeStep4: "4단계: 활성화 결과 페이지",
    activeStepInfo1: "차량에 이 카드가 나타나면",
    activeStepInfo2: "을 눌러 활성화 프로세스에 진입합니다",
    activeStepInfo3:
      "안드로이드/애플 스토어에서 앱을 다운로드할 수 있습니다. 이미 다운로드 한 경우, ",
    activeStepInfo5: "을 짧게 눌러 다음 단계로 이동할 수 있습니다.",
    activeStepInfo6:
      "App 안내에 따라 차량을 검색하여 해당 차량을 찾은 후, 차량 계기판에 표시된 4 자리 핀 코드를 입력하여 활성화를 완료합니다.",
    activeStepInfo7:
      "활성화 성공 후 성공 페이지로 이동합니다. (5분 이내에 작업을 완료해야하며, 그렇지 않으면 활성화 프로세스가 다시 시작됩니다.)",
    instrumentDescription: "계기판 전체 설명",
    instrumentStopPic: "계기판 (주차 상태) 도식도 ",
    instrumentWorkPic: "계기판 (운전 상태) 그림",
    cardPic: "집계 카드 도식화",
    instrumentInfo1:
      "스마트 카드 영역 (집계 카드, 라이딩 통계, 블루투스 음악, 블루투스 설정, 차량 건강, 차량 설정 포함)",
    instrumentInfo2: "중앙 정보 영역 (차량 건강 상태, 차량 주행 통계 포함)",
    instrumentInfo3:
      "차량 정보 영역 (모드 위치, 주행 거리 정보, 기능 활성화 상태 포함)",
    aggregatedCardArea: "스마트 카드 영역 - 집계 카드",
    aggregatedCardInfo1:
      "블루투스 음악 재생 상태를 표시하며, 음악 기능 내의 안내 문구를 통해 음악 기능 상태를 판단할 수 있습니다",
    aggregatedCardInfo2:
      "블루투스 연결 상태를 표시하며, 연결되지 않은 경우 아이콘 색상이 회색이고, 연결에 성공한 경우 아이콘 색상이 다채로워집니다.",
    aggregatedCardInfo3:
      "주행 녹화기의 온오프 상태를 표시하며, 꺼져있는 경우 아이콘 색상이 회색이고, 켜져있는 경우 아이콘 색상이 다채로워집니다.",
    aggregatedCardInfo4: "기능이 아직 오픈되지 않았습니다. 기대해 주세요.",
    cyclingStatistics: "스마트 카드 영역 - 라이딩 통계",
    cyclingPic: "자전거 타기 통계 그림",
    cyclingStatisticsInfo1:
      "이곳에서는 출하 이후 차량의 총 주행 거리가 표시됩니다.",
    cyclingStatisticsInfo2: "이곳에서는 귀하의 특정 주행 거리를 표시하며,",
    cyclingStatisticsInfo3: "을 짧게 눌러 이 데이터를 재설정할 수 있습니다.",
    BluetoothMusic: "스마트 카드 영역 - 블루투스 음악",
    BluetoothPic: "블루투스 음악 그림",
    BluetoothMusicInfo1:
      "오디오가 있을 때 이곳에 가수와 가사 이름이 표시되며, 오디오가 없을 때 이곳에 【알 수 없는 노래】가 표시됩니다 (블루투스 연결 후 이동 장치로 오디오 재생 필요)",
    BluetoothMusicInfo2: "",
    BluetoothMusicInfo3: "을 짧게 눌러 음악 재생/일시 정지를 제어합니다",
    BluetoothMusicInfo4: "",
    BluetoothMusicInfo5: "을 길게 눌러 다음 곡으로 전환합니다",
    vehicleHealth: "스마트 카드 영역 - 차량 건강",
    healthPic: "차량 건강 그림",
    warningPic: "차량 이상 그림",
    vehicleHealthInfo1:
      "차량을 시작한 후 이 카드로 전환하면 자동으로 차량 건강 상태를 감지합니다",
    vehicleHealthInfo2:
      "차량 건강 상태에 문제가 발생하면 카드에 해당 오류 정보가 표시되고",
    vehicleHealthInfo3: "버튼을 짧게 눌러 오류 세부 정보를 볼 수 있습니다",
    vehicleSetting: "스마트 카드 영역 - 차량 설정",
    settingPic: "차량 설정 도표",
    vehicleSettingInfo1:
      "이 기능은 차량 설정을 수행할 수 있습니다 (설정 항목: 블루투스 볼륨, 오토바이 사운드, 디스플레이 모드, 차량 버전, 언어 설정, 드라이브 레코더, 공장 초기화, 안전 보조, 대기 바인딩 모드, 거리 단위, 시간 단위)",
    vehicleSettingInfo2: "다른 기능을 전환하려면",
    vehicleSettingInfo3: "을 짧게 눌러 제어할 수 있습니다",
    vehicleSettingInfo4: "필요한 기능을 찾아 확인하려면",
    vehicleSettingInfo5: "을 짧게 눌러 확인할 수 있습니다",
    instrumentWorkingInfo1:
      "스마트 카드 영역 (집계 카드, 자전거 타기 통계, 블루투스 음악 포함)",
    instrumentWorkingInfo2: "중앙 정보 영역 (실시간 속도, 배터리 정보 포함)",
    instrumentWorkingInfo3:
      "차량 정보 영역 (모드 위치, 주행 거리 정보, 실시간 전류, 실시간 전력 소비 포함)",
    aggregatedCardWorkingInfo2: "이번 자전거 타기 데이터 표시",
    startCycling: "시작 라이딩",
    startInfo:
      "【Ready】키를 짧게 눌러 자전거 모드를 시작하거나 종료하십시오. 계기판은 해당 화면을 표시합니다 (자세한 내용은 아래 그림 참조)",
    gearShift: "모드 변경",
    gearNote:
      "참고: 차량에는 총 다섯 개의 모드가 있으며, 각각 【ECO】【COMFORT】【SPORT】【TURBO】【MAM】입니다.",
    H1GearNote:
      "주: 차량은 총 네 가지 모드가 있으며, 각각 【ECO】, 【COMFORT】, 【SPORT】, 【MAM】입니다.",
    gearInfo1:
      "ECO 모드는 절약 운전에 적합하며 최장 거리를 제공할 수 있습니다.",
    gearInfo2:
      "COMFORT 모드는 일상 운전에 적합하며, 범위, 가속 및 최고 속도를 균형있게 조절합니다.",
    gearInfo3:
      "SPORT 모드는 스포츠 드라이빙에 적합하며, 추월 및 최고 속도 성능을 강조합니다.",
    gearInfo4:
      "TURBO 모드는 격렬한 운전에 적합하며, 차량의 모든 잠재력을 발휘합니다.",
    gearInfo5: "MAM 모드는 차량을 밀거나 이동하는 데 적합합니다",
    gearInfo6: "M 키를 왼쪽이나 오른쪽으로 움직여 모드를 변경합니다",
    gearInfo7: "TURBO 키를 눌러 TURBO 모드로 진입합니다.",
    gearInfo8:
      "이 버튼을 길게 눌러 MAM 모드로 진입하고, 핸들을 돌리거나 M- / M+을 변경하여 차량 이동을 제어할 수 있습니다(M-은 후진, M+은 전진)",
    gearInfo9: "M 키를 눌러 모드를 변경합니다",
    gearInfo10:
      "이 버튼을 길게 눌러 MAM 모드로 들어간 다음 M-/M+를 사용하여 차량 이동을 제어할 수 있습니다 (M- 후진; M+ 전진).",
    drivingPage: "운전 페이지",
    parkingPage: "주차 페이지",
    gearPic: "모드 정보 표시 영역 도표",
    questions,
    troubles
  }
};

export default kr;



// WEBPACK FOOTER //
// ./src/i18n/langs/kr.js